import React, { Dispatch, SetStateAction } from 'react';
import { HeadCellImplementationProps } from '../../../../../components/muiLegacy/Tables/KeywordTable/HeadCells/models';
import { CommandGq } from '../../../../../graphql/projects/queries/contentPlan/useGetContentTasksGq';
import { List, ListItem } from '@material-ui/core';
import HeadCell from '../../../../../components/muiLegacy/Tables/Shared/HeadCell';
import { projectsApiService } from '../../../../../graphql/projects/projectsApiService';
import HeadCellStandardOptions from '../../../../../components/muiLegacy/Tables/Shared/HeadCellStandardOptions';
import VoxelMenuItemContainer from '../../../../../components/voxel/PopoverMenu/VoxelMenuItemContainer';

export interface HeadCellStatusCodeProps extends HeadCellImplementationProps {
  command: CommandGq;
  setCommand: Dispatch<SetStateAction<CommandGq>>;
  projectId: number;
}

const HeadCellStatusCode: React.FC<HeadCellStatusCodeProps> = ({
  command,
  setCommand,
  projectId,
  basicConfig,
  basicState,
}) => {
  const { query, contentHttpStatus } = projectsApiService.queries.useGetContentHttpStatus({
    projectId: projectId,
  });

  const handleFilterChange = (value: number) => {
    setCommand((prev) => {
      const previouslySelected = prev.filtering.statusCodes.includes(value);
      const nextStatusCodes = prev.filtering.statusCodes.filter(
        (statusCode) => statusCode !== value
      );
      !previouslySelected && nextStatusCodes.push(value);
      return {
        ...prev,
        filtering: { ...prev.filtering, statusCodes: nextStatusCodes },
      };
    });
  };

  return (
    <HeadCell
      hasFilter={!!command.filtering.statusCodes.length}
      align={'center'}
      basicConfig={basicConfig}
      basicState={basicState}
    >
      <VoxelMenuItemContainer size="md">
        <HeadCellStandardOptions basicConfig={basicConfig} basicState={basicState} />
        <List>
          {contentHttpStatus.map((statusCode, index) => {
            return (
              <ListItem
                selected={command.filtering.statusCodes.includes(statusCode)}
                key={index}
                button
                onClick={() => handleFilterChange(statusCode)}
              >
                {statusCode ?? '-'}
              </ListItem>
            );
          })}
        </List>
      </VoxelMenuItemContainer>
    </HeadCell>
  );
};

export default HeadCellStatusCode;
